import { render, staticRenderFns } from "./Record3List.vue?vue&type=template&id=eafd8af8&scoped=true&"
import script from "./Record3List.vue?vue&type=script&lang=ts&"
export * from "./Record3List.vue?vue&type=script&lang=ts&"
import style0 from "./Record3List.vue?vue&type=style&index=0&id=eafd8af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafd8af8",
  null
  
)

export default component.exports